<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
      language: 'setting/getLanguage',
      shouldUpdate: 'menu/getShouldUpdate',
    }),
  },
  watch: {
    shopId(shopId) {
      // 日本、台湾、アメリカのWEB認証、アプリ認証では下記処理を行う。※事前注文は以降の処理で行う。
      if (shopId !== null && this.seatNo !== null) {
        this.fetchMenu()
      }
      // KOA-2620 日本のアプリでの事前注文用認証でのメニュー取得処理。
      if (
        shopId !== null &&
        process.env.VUE_APP_LANG === 'ja' &&
        process.env.VUE_APP_TYPE === 'app'
      ) {
        this.fetchMenu()
      }
    },
    language() {
      if (this.shopId) {
        this.fetchMenu(true)
      }
    },
    async shouldUpdate(bool) {
      if (bool) {
        this.setShouldUpdate(false)
        await this.fetchMenu()
      }
    },
  },
  methods: {
    ...mapActions({
      fetchMenu: 'menu/fetchMenu',
      setShouldUpdate: 'menu/setShouldUpdate',
    }),
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
